module.exports = __webpack_public_path__ + "static/media/RapBattlePoster.c8d6b9d3.jpg";